export const baseURL = "https://staging-api-portal.uniadmissions.co.uk/"
